import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IActivityTask } from '../../Redux/activityModels';
import { translateWorkflowTaskDescription } from '../../utils';
import ActivityStatusBadge from '../shared/ActivityStatusBadge';
import ActivityRetryButton from '../shared/ActivityRetryButton';
import ActivityDebugTags from '../shared/ActivityDebugTags';

export interface ActivityTaskItemProps {
  task: IActivityTask;
  isRetrying: boolean;
  onRetry: (taskId: string) => void;
  index: number;
  correlationId: string;
}

const ActivityTaskItem: React.FC<ActivityTaskItemProps> = React.memo(({ task, isRetrying, onRetry, index, correlationId }) => {
  const { t } = useTranslation();

  const handleRetry = useCallback(() => {
    onRetry(task.id);
  }, [task.id, onRetry]);

  return (
    <div
      className={`tw-flex tw-flex-col tw-gap-2 tw-px-6 tw-py-3${index > 0 ? ' tw-border-t activity-border-divider' : ''}`}
      data-testid="task-item"
    >
      <div className="tw-flex tw-items-center tw-gap-3">
        <span className="tw-text-sm activity-text-primary">{translateWorkflowTaskDescription(task.description, t)}</span>
        <div className="tw-flex tw-items-center tw-gap-2">
          <ActivityStatusBadge 
            status={task.status} 
            showFailedIcon={false}
          />
          {task.retry && (
            <ActivityRetryButton
              className="activity-retry-btn"
              onClick={handleRetry}
              isRetrying={isRetrying}
            />
          )}
        </div>
      </div>
      <ActivityDebugTags 
        correlationId={correlationId}
        taskId={task.id}
        status={task.status}
      />
    </div>
  );
});

export default ActivityTaskItem;
